import { NL_Kasa } from './../models/NL_Kasa';
import { BllKasalar } from './bll/bll-kasalar';
import { Vw_Cariler } from './../models/Vw_Cariler';
import { BLLViewCariler } from './bll/bll-viewCariler';
import { BLLCariKartlar } from './bll/bll-carikart';
import { BllViewStoklar } from './bll/bll-ViewStoklar';
import { Vw_Stoklar } from './../models/Vw_Stoklar';
import { BllOrtak } from './bll/bll-ortak';
import { BllKategoriler } from './bll/bll-kategoriler';
import { BllMarkalar } from './bll/bll-markalar';
import { BllKdvGruplar } from './bll/bll-kdvgruplari';
import { BllBirimler } from './bll/bll-birimler';
import { BllBarcode } from './bll-nlbarcode';
import { BllStoklar } from './bll/bll-stoklar';
import { Servis } from './servis';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Ortak } from './ortak';
import { NL_StokKarti } from '../models/NL_StokKarti';
import { NL_Birim } from '../models/NL_Birim';
import { NL_Kategoriler } from '../models/NL_Kategoriler';
import { NL_KDVGrup } from '../models/NL_KDVGup';
import { NL_Marka } from '../models/NL_Marka';
import { NL_CariKart } from '../models/NL_CariKart';



@Injectable()
export class SyncProvider {
    eklenecek_stokkartlari = [];
    guncellenecek_stokkartlari = [];
    eklenecek_carikartlari = [];
    guncellenecek_carikartlari = [];
    eklenecek_carikartlariview = [];
    guncellenecek_carikartlariview = [];
    eklenecek_birimler = [];
    guncellencek_kategoriler = [];
    eklenecek_kategoriler = [];
    eklenecek_markalar = [];
    eklenecek_kdvgruplari = [];
    eklenecek_kasalar = [];
    guncellenecek_kasalar = [];


    barcode = [];
    servisBilgisiExt: String = "/Api/Servis.aspx?key=N9ySoNLaS2_18&firma=MRC&t=";
    constructor(public servis: Servis,
        public ortak: Ortak,
        public bllstokkart: BllStoklar,
        public bllbirimler: BllBirimler,
        public bllkdvler: BllKdvGruplar,
        public bllmarkalar: BllMarkalar,
        public bllkategoriler: BllKategoriler,
        public bllbarcode: BllBarcode,
        public bllOrtak: BllOrtak,
        public bllviewStoklar: BllViewStoklar,
        public bllcarikartlar: BLLCariKartlar,
        public bllviewcarikartlar: BLLViewCariler,
        public bllkasalar: BllKasalar,
    ) {

    }

    ///////NL stokkarti////////
    stokKartiSunucudanGetir() {
        return new Promise((res, err) => {

            this.stokKartSunucudanGetirSync().then(a => {
                this.stokKartSunucudanGetirSyncResult(a).then(b => {

                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })

    }

    stokKartSunucudanGetirSync() {

        return new Promise((resolve, reject) => {
            this.bllOrtak.islemWithoutPost("StoklarSync", "", false).then((result) => {

                var sonuc = <any>result;

                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {
                     

                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }

    stokKartSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var guncellenecekLokalStoklar: NL_StokKarti[] = result;
            var eklenecekLokalStoklar: NL_StokKarti[] = result;

            //Eklenecek kayıtlar
            for (let item of guncellenecekLokalStoklar) {
                this.guncellenecek_stokkartlari.push(item.ID);
            }
            for (let item of eklenecekLokalStoklar) {
                this.eklenecek_stokkartlari.push(item.ID);

            }
            this.bllstokkart.bulkUpdate(guncellenecekLokalStoklar, "ID").then(a => {
                this.bllstokkart.bulkInsert(eklenecekLokalStoklar).then(a => {
                    resolve(a);
                });
            })
        }).then(a => {
            result(a);
        })


    }
    ///////NL stokkarti////////
    ////// Stoklar View//////////
    stokBilgisiSunucudanGetir() {
        return new Promise((res, err) => {

            this.stokBilgisiSunucudanGetirSync().then(a => {
                this.stokBilgisiSunucudanGetirSyncResult(a).then(b => {

                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })

    }

    stokBilgisiSunucudanGetirSync() {

        return new Promise((resolve, reject) => {
            this.bllOrtak.islemWithoutPost("StoklarViewSync", "", false).then((result) => {

                var sonuc = <any>result;
                console.log("aaa",sonuc.SonucObject)
        

                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {
                       

                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }

    stokBilgisiSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var guncellenecekLokalStoklar: Vw_Stoklar[] = result;
            var eklenecekLokalStoklar: Vw_Stoklar[] = result;

            //Eklenecek kayıtlar
            for (let item of guncellenecekLokalStoklar) {
                this.guncellenecek_stokkartlari.push(item.ID);
            }
            for (let item of eklenecekLokalStoklar) {
                this.eklenecek_stokkartlari.push(item.ID);

            }
            this.bllviewStoklar.bulkUpdate(guncellenecekLokalStoklar, "ID").then(a => {
                this.bllviewStoklar.bulkInsert(eklenecekLokalStoklar).then(a => {
                    resolve(a);
                });
            })
        }).then(a => {
            result(a);
        })


    }
    ////// Stoklar View//////////
    stokKartMmxIslemleri() {

        return new Promise((resolve, reject) => {
            let body = new FormData();
            body.append('mmx_add_items', this.eklenecek_stokkartlari.join());
       
            this.servis.makePostRequestWithoutJsonResult(this.ortak.storageServisBilgisiGetir.ADRES + this.servisBilgisiExt + "StokMmxOperations", body).then((result) => {

                this.eklenecek_stokkartlari = [];
                resolve(result);
            }, (error) => {
               

                reject(error);
            });
        });

    }


    //////////Cari İşlemleri///////////
    cariKartiSunucudanGetir() {
        return new Promise((res, err) => {

            this.cariKartSunucudanGetirSync().then(a => {
                this.CariKartSunucudanGetirSyncResult(a).then(b => {
                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })
    }
    cariKartSunucudanGetirSync() {
        return new Promise((resolve, reject) => {
            this.bllOrtak.islemWithoutPost("CarilerSync", "", false).then((result) => {
                var sonuc = <any>result;
                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {
                       

                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }
    CariKartSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var guncellenecekLokalStoklar: NL_CariKart[] = result;
            var eklenecekLokalStoklar: NL_CariKart[] = result;

            //Eklenecek kayıtlar
            for (let item of guncellenecekLokalStoklar) {
                this.guncellenecek_carikartlari.push(item.ID);
            }
            for (let item of eklenecekLokalStoklar) {
                this.eklenecek_carikartlari.push(item.ID);

            }
            this.bllcarikartlar.bulkUpdate(guncellenecekLokalStoklar, "ID").then(a => {
                this.bllcarikartlar.bulkInsert(eklenecekLokalStoklar).then(a => {
                    resolve(a);
                });
            })
        }).then(a => {
            result(a);
        })


    }
    cariKartViewSunucudanGetir() {
        return new Promise((res, err) => {

            this.cariKartViewSunucudanGetirSync().then(a => {
                this.CariKartViewSunucudanGetirSyncResult(a).then(b => {

                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })
    }


    cariKartViewSunucudanGetirSync() {
        return new Promise((resolve, reject) => {
            this.bllOrtak.islemWithoutPost("CarilerViewSync", "", false).then((result) => {
                var sonuc = <any>result;
                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {
                     
                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }

    CariKartViewSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var guncellenecekLokalStoklar: Vw_Cariler[] = result;
            var eklenecekLokalStoklar: Vw_Cariler[] = result;

            //Eklenecek kayıtlar
            for (let item of guncellenecekLokalStoklar) {
                this.guncellenecek_carikartlariview.push(item.ID);
            }
            for (let item of eklenecekLokalStoklar) {
                this.eklenecek_carikartlariview.push(item.ID);

            }
            this.bllviewcarikartlar.bulkUpdate(guncellenecekLokalStoklar, "ID").then(a => {
                this.bllviewcarikartlar.bulkInsert(eklenecekLokalStoklar).then(a => {
                    resolve(a);
                });
            })
        }).then(a => {
            result(a);
        })
    }

    ///////////Birim İşlemleri///////////

    BirimleriSunucudanGetir() {
        return new Promise((res, err) => {

            this.BirimleriSunucudanGetirSync().then(a => {
                this.BirimleriSunucudanGetirSyncResult(a).then(b => {

                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })

    }

    BirimleriSunucudanGetirSync() {
        return new Promise((resolve, reject) => {
            this.bllOrtak.islemWithoutPost("BirimlerSync", "", false).then((result) => {
                var sonuc = <any>result;
                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {

                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }
    BirimleriSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var eklenecekLokalBirimler: NL_Birim[] = result;


            //Eklenecek kayıtlar
            for (let item of eklenecekLokalBirimler) {
                this.eklenecek_birimler.push(item.ID);
            }

            this.bllbirimler.bulkInsert(eklenecekLokalBirimler).then(a => {


                resolve(a);


            }).catch((err) => reject(err))
        })
    }
    ///////////Birim İşlemleri///////////

    ///////////Kategori İşlemleri///////////
    KategorileriSunucudanGetir() {
        return new Promise((res, err) => {

            this.KategorileriSunucudanGetirSync().then(a => {
                this.KategorileriSunucudanGetirSyncResult(a).then(b => {

                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })

    }

    KategorileriSunucudanGetirSync() {
        return new Promise((resolve, reject) => {
            this.bllOrtak.islemWithoutPost("KategorilerSync", "", false).then((result) => {
                var sonuc = <any>result;
                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {

                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }
    KategorileriSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var guncellenecekLokalKategoriler: NL_Kategoriler[] = result;
            var eklenecekLokalKategoriler: NL_Kategoriler[] = result;

            //Eklenecek kayıtlar
            for (let item of guncellenecekLokalKategoriler) {
                this.guncellencek_kategoriler.push(item.ID);
            }
            for (let item of eklenecekLokalKategoriler) {
                this.eklenecek_kategoriler.push(item.ID);

            }
            this.bllkategoriler.bulkUpdate(guncellenecekLokalKategoriler, "ID").then(a => {
                this.bllkategoriler.bulkInsert(eklenecekLokalKategoriler).then(a => {
                    resolve(a);
                });
            })
        }).then(a => {
            result(a);
        })
    }
    ///////////Kategori İşlemleri///////////

    ///////////Kdv İşlemleri///////////
    KdvleriSunucudanGetir() {
        return new Promise((res, err) => {

            this.KdvleriSunucudanGetirSync().then(a => {
                this.KdvleriSunucudanGetirSyncResult(a).then(b => {

                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })

    }

    KdvleriSunucudanGetirSync() {
        return new Promise((resolve, reject) => {
            this.bllOrtak.islemWithoutPost("KdvGruplariSync", "", false).then((result) => {
                var sonuc = <any>result;

                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {


                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }
    KdvleriSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var eklenecekLokalKdvler: NL_KDVGrup[] = result;



            //Eklenecek kayıtlar
            for (let item of eklenecekLokalKdvler) {
                this.eklenecek_kdvgruplari.push(item.ID);

            }

            this.bllkdvler.bulkInsert(eklenecekLokalKdvler).then(a => {


                resolve(a);

            }).catch((err) => reject(err))
        }).then(a => {
            result(a);
        })
    }
    ///////////Kdv İşlemleri///////////

    ///////////marka İşlemleri///////////

    MarkalariSunucudanGetir() {
        return new Promise((res, err) => {

            this.MarkalariSunucudanGetirSync().then(a => {
                this.MarkalariSunucudanGetirSyncResult(a).then(b => {

                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })

    }

    MarkalariSunucudanGetirSync() {
        return new Promise((resolve, reject) => {
            this.servis.makeGetRequest(this.ortak.storageServisBilgisiGetir.ADRES + this.servisBilgisiExt + "MarkalarSync").then((result) => {
                var sonuc = <any>result;
                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {

                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }
    MarkalariSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var eklenecekLokalMarkalar: NL_Marka[] = result;

            for (let item of eklenecekLokalMarkalar) {
                this.eklenecek_markalar.push(item.ID);
            }

            this.bllmarkalar.bulkInsert(eklenecekLokalMarkalar).then(a => {

                resolve(a);


            }).catch((err) => reject(err))
        })
    }

    ///////////marka İşlemleri///////////
    ///////////Kasa İşlemleri///////////
    KasalariSunucudanGetir() {
        return new Promise((res, err) => {

            this.KasalariSunucudanGetirSync().then(a => {
                this.KasalariSunucudanGetirSyncResult(a).then(b => {

                }).catch(y => {
                    err(y);
                })
            }).catch(z => {
                err(z);
            });
        })

    }

    KasalariSunucudanGetirSync() {
        return new Promise((resolve, reject) => {
            this.bllOrtak.islemWithoutPost("KasalarSync", "", false).then((result) => {
                var sonuc = <any>result;

                if (sonuc.Sonuc != null) {
                    if (sonuc.Sonuc == 1) {


                        resolve(sonuc.SonucObject);
                    }
                    else {
                        reject();
                    }
                }
                else
                    resolve(result);
            }, (error) => {
                reject(error);
            });
        });
    }
    KasalariSunucudanGetirSyncResult(result) {
        return new Promise((resolve, reject) => {
            var eklenecekLokalKasalar: NL_Kasa[] = result;
            var guncellenecekLokalKasalar: NL_Kasa[] = result;

            for (let item of guncellenecekLokalKasalar) {
                this.guncellenecek_kasalar.push(item.ID);

            }

            for (let item of eklenecekLokalKasalar) {
                this.eklenecek_kasalar.push(item.ID);

            }
            this.bllkasalar.bulkUpdate(guncellenecekLokalKasalar, "ID").then(a => {
                this.bllkasalar.bulkInsert(eklenecekLokalKasalar).then(a => {
                    resolve(a);
                });
            })
        }).then(a => {
            result(a);
        })
    }
}



// WEBPACK FOOTER //
// ./src/providers/syncProvider.ts